module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/btn-apply@3x-0f868b775f4c875cc96aed0bcc044abe.png";